import React from 'react';
import { Route } from 'react-router-dom';
import UserRecovery from '../login/recovery';
import VolumetryPage from '../components/whatsapp/volumetry/VolumetryPage';
import ReportSettingsPage from '../components/whatsapp/reportSettings/ReportSettingsPage';

export default [
  <Route exact path="/login/recovery" component={UserRecovery} noLayout/>,
  <Route exact path="/whatsapp_volumetry" component={VolumetryPage} />,
  <Route exact path="/whatsapp_report_settings" component={ReportSettingsPage} />,
];